export default __webpack_public_path__ + "static/media/background-squares.ca8bb211.png";